import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useHistory } from 'react-router-dom';

import ContentResource from 'resources/Profile/ContentResource';

import StyledChip from '../ui/StyledComponents/StyledChip';
import StyledMenu from '../ui/StyledComponents/StyledMenu';

import { useError } from 'utils/useErrorController';

import {  MenuItem } from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CloseIcon from '@mui/icons-material/Close';

import { t } from 'i18n/index';

const TagsFilter = ({ organizationSlug, organizationTags, activeTag }) => {

    const [selectedTag, setSelectedTag] = useState(activeTag)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const history = useHistory();

    const {handleError} = useError();
    const onTagSelect = async (tag) => {
      try {
        setAnchorEl(null);
        const isTagActive = selectedTag?.id === tag.id;

        const newUrl = isTagActive ? window.location.pathname : `?tag=${tag.name}`;
        history.replace(newUrl);

        setSelectedTag(isTagActive ? null : tag);
        await fetch(ContentResource.list(), { organization_slug: organizationSlug, page: 1, tag_id: isTagActive ? null : tag.id });

      } catch (error) {
        handleError(error)
      }
    };

    const handleClick = (event) => {
      event.preventDefault();
      setAnchorEl(event.currentTarget);
    };

    const handleClose = (event) => {
      event.preventDefault();
      setAnchorEl(null);
    };

  return (
    <div className='tags'>
      <StyledChip
        label={activeTag ? activeTag.name : t('literal:filter') }
        variant="outlined"
        onClick={(e) => activeTag ? onTagSelect(activeTag) : handleClick(e)}
        onDelete={(e) => activeTag ? onTagSelect(activeTag) : handleClick(e)}
        deleteIcon={activeTag ? <CloseIcon /> : <FilterAltIcon />} />

      <StyledMenu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {organizationTags.map((tag) => (
          <MenuItem
            key={tag.id}
            value={tag.id}
            onClick={() => onTagSelect(tag)}
          >
            {tag.name}
          </MenuItem>
        ))}
      </StyledMenu>
    </div>
  );
};

TagsFilter.propTypes = {
    organizationSlug: PropTypes.string,
    organizationTags: PropTypes.array,
    activeTag: PropTypes.number,
};

export default TagsFilter;
